export default __webpack_public_path__ + "static/media/chest-locked.453f7a29.webp";